import { useState } from "react";
import { Document, Thumbnail, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import { cn } from "../../lib/utils";

// Share the same worker as PdfViewer
if (!pdfjs.GlobalWorkerOptions.workerSrc) {
  pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";
}

interface PdfThumbnailProps {
  url: string;
  width?: number;
  className?: string;
}

/**
 * Renders a lightweight first-page thumbnail of a PDF.
 * Uses react-pdf with text/annotation layers disabled for performance.
 */
export function PdfThumbnail({ url, width = 200, className }: PdfThumbnailProps) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  if (error) return null;

  return (
    <div className={cn("flex items-center justify-center overflow-hidden", className)}>
      <Document
        file={url}
        loading={null}
        error={null}
        onLoadSuccess={() => setLoaded(true)}
        onLoadError={() => setError(true)}
        className="flex items-center justify-center"
      >
        <Thumbnail
          pageNumber={1}
          width={width}
          onItemClick={() => {
            /* no-op: navigation is handled by the parent AssetCard onClick */
          }}
          className={cn(
            "transition-opacity duration-[180ms]",
            loaded ? "opacity-100" : "opacity-0",
          )}
        />
      </Document>
    </div>
  );
}
